import axios from 'axios'
import store from '@/store'
import router from '@/router'
import {toast} from "../class/Notification";
import {removeBlankAttributes} from "../class/Converter";
import {findObjectIndex} from "../class/Converter";

const reshapeForm = (form) => {
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('last_name', form.last_name);
    formData.append('email', form.email);
    formData.append('cellphone', form.cellphone);
    formData.append('password', form.password);
    formData.append('password_confirmation', form.password_confirmation);
    formData.append('role', form.role);
    return formData
}

export default {
    namespaced: true,
    state: {
        persons: [],
        trash: [],
        person: {},
        links: {},
        meta: {},
        profile: {},
        token: null,
    },
    mutations: {
        setPersons(state, persons) {
            state.persons = persons;
        },
        setTrash(state, trash) {
            state.trash = trash;
        },
        setPerson(state, person) {
            state.person = person;
            state.person.password = '';
            state.person.password_confirmation = '';
            state.person.current_password = '';
        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        removePerson: (state, person) => {
            state.persons.splice(findObjectIndex(state.persons, person), 1)
            state.trash.splice(findObjectIndex(state.trash, person), 1)
        },
        setUser(state, user) {
            state.profile = user;
        },
        setToken(state, token) {
            state.token = token;
        },

    },
    actions: {
        getPersons({commit}, page = 1) {
            axios.get(`user?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setPersons', res.data);
                    commit("setLinks", res.links);
                    commit("setMeta", res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        getTrash({commit}, page = 1) {
            axios.post(`user/trash?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setTrash', res.data);
                    commit('setMeta', res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        async getPerson({commit}, id) {
            await axios.get(`user/${id}`)
                .then(res => {
                    res = res.data.data
                    commit('setPerson', res);
                    return res.data;
                })
                .catch(error => {
                    router.push({name: 'NotFound'})
                })
        },
        deletePerson({commit}, person) {
            axios.delete(`user/${person.id}`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('کاربر با موفقیت حذف شد ', 'کاربر با موفقیت حذف شد ')
                    commit('removePerson', person)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        forceDeletePerson({commit}, person) {
            axios.delete(`user/${person.id}/force-delete`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('کاربر با موفقیت حذف شد ', 'کاربر با موفقیت حذف شد ')
                    commit('removePerson', person)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        restorePerson({commit}, person) {
            axios.put(`user/${person.id}/restore`)
                .then(res => {
                    const deleted = res.data.data;

                    commit('removePerson', person)
                    toast('کاربر با موفقیت بازیابی شد ', 'کاربر با موفقیت بازیابی شد ')
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        updatePerson({commit}, form) {
            const formData = removeBlankAttributes(form);

            axios.put(`/user/${form.id}`, formData)
                .then(res => {
                    const person = res.data.data.user;

                    toast('عملیات با موفقیت انجام شد', 'به روز رسانی با موفقیت انجام شد')
                    commit('setPerson', person)
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
        },
        createPerson({commit}, form) {
            const formData = removeBlankAttributes(form);
            axios.post(`/user/create`, formData)
                .then(res => {
                    const person = res.data.data.user;
                    toast('عملیات با موفقیت انجام شد', 'ساخت کاربر جدید با موفقیت انجام شد')
                    router.push({name: 'UpdateUser', params: {id: person.id}})
                    commit('setPerson', persons)

                })
                .catch(error => {
                    console.log(error)
                });
        },
        setUserState({commit}, res) {
            const token = res.data.data.token
            const profile = res.data.data.user;
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('setUser', profile)
            commit('setToken', token)
        },
        setToken({commit}, token) {
            commit('setToken', token)
        },
        setProfile({commit}, profile) {
            commit('setUser', profile)
        },
        editProfile({commit}, form) {
            const userId = store.getters['User/getUserId'];
            form = removeBlankAttributes(form)
            axios.put(`/user/${userId}`, form).then(res => {
                const profile = res.data.data.user;
                toast('عملیات با موفقیت انجام شد', 'به روز رسانی با موفقیت انجام شد')
                commit('setUser', profile)
            }).catch(error => {
                console.log(error)
            })
        },
        searchUsers({commit}, form) {
            axios.post('/user/search', form)
                .then(response => {
                    const data = response.data
                    commit('setPersons', data.data.data);
                    commit('setLinks', data.data.links);
                    commit('setMeta', data.data.meta);
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    getters: {
        getPersons: state => state.persons,
        getTrash: state => state.trash,
        getPerson: (state) => state.person,
        getPaginationLinks: (state) => state.links,
        getPaginationMeta: (state) => state.meta,

        getToken: state => state.token,
        getProfile: state => state.profile,
        getUserId: state => state.profile.id,
        getUserCellphone: state => state.profile.cellphone,
        getUserEmail: state => state.profile.email,
        isPhoneVerified: state => state.profile.cellphone_verified_at !== null,
        isEmailVerified: state => state.profile.email_verified_at !== null,
        isAuthenticated: state => state.token !== null,
        isAdmin: state => state.profile.role === 1,
    }
}